import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/** Locales the report is translated into. Mirrors the `lang` enum of GET /api/company-report/pdf. */
export type ReportLang = 'fr' | 'en' | 'nl';

/** Company-wide PDF summary report, filtered like the Excel export. */
@Injectable({
  providedIn: 'root',
})
export class CompanyReportService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/company-report/pdf`;

  download(lang: ReportLang, year?: number, clientId?: string) {
    let params = new HttpParams().set('lang', lang);
    if (year) {
      params = params.set('year', year.toString());
    }
    if (clientId) {
      params = params.set('clientId', clientId);
    }

    return this.http.get(this.apiUrl, {
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }
}
